import {JsonObject} from 'utilities/types'
import {IPackage} from '../'
import {CBaseRecord} from './_base'

export class CPackage extends CBaseRecord<IPackage> implements IPackage {
  static record_name = 'package'
  static external_id = 'package_id'

  id: string
  name?: string
  features?: string[]
  is_custom?: boolean
  base_price?: number
  per_seat_price?: number
  per_delegate_price?: number

  constructor(data: IPackage & JsonObject) {
    super(data)
    this.id = data.id ?? ''
    this.name = data.name
    this.features = data.features
    this.is_custom = data.is_custom
    this.base_price = data.base_price
    this.per_seat_price = data.per_seat_price
    this.per_delegate_price = data.per_delegate_price
  }
}
